<template>
  <div>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
        >
          <el-form-item label="订单号" prop="number">
            <el-input
              size="small"
              v-model="filter.number"
              @keyup.enter.native="requestSearch"
              autocomplete="off"
              placeholder="订单号或合同号"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="中间商"
            prop="dealer_id"
            v-if="userInfo.dealer_id == 0"
          >
            <dealer-select
              style="width: 100%"
              :val="filter.dealer_id"
              @change="filter.dealer_id = $event"
            ></dealer-select>
          </el-form-item>

          <el-form-item
            label="订单来源"
            prop="is_quotation"
            v-if="userInfo.dealer_id == 0"
          >
            <el-select v-model="filter.is_quotation" clearable size="small">
              <el-option
                v-for="(value, index) in CommodityOrderQuotationMap"
                :key="index"
                :label="value"
                :value="parseInt(index)"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="报价客户"
            prop="quotation_customer_id"
            v-if="userInfo.dealer_id == 0"
          >
            <customer-select
              style="width: 100%"
              :val="filter.quotation_customer_id"
              @change="filter.quotation_customer_id = $event"
            ></customer-select>
          </el-form-item>

          <el-form-item label="最终客户" prop="customer_id">
            <customer-select
              style="width: 100%"
              :val="filter.customer_id"
              @change="filter.customer_id = $event"
            ></customer-select>
          </el-form-item>

          <el-form-item label="件号" prop="part_number">
            <el-input
              size="small"
              v-model="filter.part_number"
              @keyup.enter.native="requestSearch"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <!-- <el-form-item label="状态" prop="status">
            <el-select v-model="filter.status" clearable size="small">
              <el-option
                v-for="(item, index) in CommodityOrderStatusMap"
                :label="item.name"
                :key="index"
                :value="index"
              ></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label="下单日期" prop="date">
            <el-date-picker
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button type="primary" size="small" @click="requestSearch"
            >筛选</el-button
          >
          <el-button size="small" @click="requestSearch('reset')"
            >重置</el-button
          >
        </div>
      </div>
    </div>

    <div class="panel mt-20">
      <div class="header">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          v-if="status == 0"
          @click="customerSelectorVisible = true"
          v-permission="Auth.commodityOrderItemUpdate"
          >添加订单</el-button
        >
        <file-button
          style="float: right"
          v-if="status == 6"
          v-permission="Auth.commodityOrderIE"
          obj="commodity_order"
          :filter="filter"
          :importButton="false"
          exportBtnName="对账单导出"
          class="mobile-hide"
        ></file-button>
      </div>

      <el-table
        v-if="!isMobile()"
        :data="list"
        stripe
        style="width: 100%"
        v-loading="loading"
        :key="tableKey"
      >
        <el-table-column align="left" label="订单详情" min-width="280px">
          <template slot-scope="scope">
            <div>
              <el-tag
                size="mini"
                effect="dark"
                type="primary"
                v-if="userInfo.dealer_id == 0"
                >{{
                  CommodityOrderQuotationMap[scope.row.is_quotation]
                }}</el-tag
              >
              <el-tag
                class="ml-5"
                size="mini"
                effect="dark"
                type="success"
                v-if="scope.row.bq == 2"
                >批量</el-tag
              >
              订单号：{{ scope.row.number }}
            </div>
            <div
              class="item-container"
              v-for="item in scope.row.items"
              :key="item.id"
            >
              <div class="flex-row" style="width: 100%">
                <div style="width: 40px; height: 40px">
                  <auth-img
                    tag="el-image"
                    :src="item.cover"
                    style="width: 40px; height: 40px"
                    fit="cover"
                    ><div slot="error" class="image-slot">暂无</div></auth-img
                  >
                </div>
                <div class="item-info">
                  <div class="item-title">
                    <div>
                      <span class="part-number"
                        >{{ item.part_number
                        }}<i class="font-12 font-normal"
                          >（{{ item.type_name }}）</i
                        >
                        <el-tag size="mini" class="mr-5">{{
                          item.commodity_category_name
                        }}</el-tag>
                        <template v-if="userInfo.dealer_id == 0">
                          <el-tag
                            size="mini"
                            type="danger"
                            class="mr-5"
                            v-if="
                              scope.row.status == 2 && item.whether_approve == 2
                            "
                            >下单审批</el-tag
                          ><el-tag
                            size="mini"
                            type="danger"
                            v-if="
                              (scope.row.status == 2 ||
                                scope.row.status == 12) &&
                              item.whether_approve != 2 &&
                              item.ec_approve == 2
                            "
                            >EC审批</el-tag
                          >
                        </template>
                      </span>
                    </div>
                    <span>x {{ item.number }}</span>
                  </div>
                  <span class="item-desc">{{ item.description }}</span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="中间商/最终客户/报价客户"
          prop="dealer.name"
          v-if="userInfo.dealer_id == 0"
          min-width="220px"
        >
          <template slot-scope="scope">
            {{ scope.row.dealer.name || '-' }}
            <br />
            <span style="opacity: 0.5">
              {{ scope.row.customer.name || '-' }}</span
            >
            <br />
            {{
              scope.row.is_quotation == 1
                ? '-'
                : scope.row.quotation_customer.name || '-'
            }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="最终客户"
          prop="customer.name"
          min-width="200px"
          v-if="userInfo.dealer_id > 0"
        >
          <template slot-scope="scope">
            {{ scope.row.customer.name || '无' }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="金额" width="120px">
          <template slot-scope="scope">
            ￥{{ scope.row.total_price.toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" min-width="200px">
          <template slot-scope="scope">
            <div class="order-time">
              {{
                $time(new Date(scope.row.created_at)).format('YYYY-MM-DD HH:mm')
              }}
            </div>
            <status-tag
              :name="
                CommodityOrderStatusMap[
                  scope.row.approve_status == 2 ? 2 : scope.row.status
                ].name
              "
              :type="
                CommodityOrderStatusMap[
                  scope.row.approve_status == 2 ? 2 : scope.row.status
                ].type
              "
            >
            </status-tag>
            <span class="text-success" v-if="scope.row.status == 6">{{
              $time(new Date(scope.row.payed_at)).format('YYYY-MM-DD')
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="220">
          <template slot-scope="scope">
            <el-popconfirm
              v-if="scope.row.status == 2 || scope.row.status == 5"
              v-permission="Auth.commodityOrderCancel"
              :title="`确认取消吗？`"
              @confirm="handleCancel(scope.row, scope.$index)"
            >
              <el-button slot="reference" type="danger" plain size="mini"
                >取消</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              v-permission="Auth.commodityOrderDelete"
              :title="`确认删除吗？`"
              v-if="scope.row.status == 1 || scope.row.status == 3"
              @confirm="handleDelete(scope.row, scope.$index)"
            >
              <el-button slot="reference" type="danger" plain size="mini"
                >删除</el-button
              >
            </el-popconfirm>

            <!-- <el-button
              class="ml-10"
              type="primary"
              plain
              size="mini"
              v-if="scope.row.status == 5"
              v-permission="Auth.commodityOrderManage"
              @click="handlePay(scope.$index, scope.row)"
              >支付</el-button
            > -->
            <!-- <el-button
              class="ml-10"
              type="primary"
              plain
              size="mini"
              v-permission="Auth.commodityOrderApprove"
              v-if="scope.row.status == 2"
              @click="handleApprove(scope.row, scope.$index)"
              >审批</el-button
            > -->

            <el-button
              type="primary"
              plain
              size="mini"
              v-if="scope.row.status == 6"
              v-permission="Auth.commodityOrderFinish"
              @click="handleFinish(scope.row, scope.$index)"
              >完成</el-button
            >

            <router-link
              :to="`${$route.path}/${scope.row.id}`"
              v-permission="Auth.commodityOrderDetail"
              ><el-button class="ml-10" type="primary" plain size="mini"
                >详情</el-button
              ></router-link
            >
            <!-- <el-button
              class="ml-10"
              type="primary"
              plain
              size="mini"
              v-permission="Auth.commodityOrderContractExport"
              v-if="
                scope.row.status == 5 ||
                scope.row.status == 6 ||
                scope.row.status == 100
              "
              @click="handleContractExport(scope.row, scope.$index)"
              >合同</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        @current-change="handlePageChange"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>

    <pay-former
      :model="model"
      :show.sync="payFormVisible"
      @updated="updatedCallback"
    ></pay-former>

    <CustomerSelector
      :show.sync="customerSelectorVisible"
      @selected="selectedOrderCustomer"
    ></CustomerSelector>
  </div>
</template>

<script>
import {
  commodityOrderList,
  deleteCommodityOrder,
  updateCommodityOrderStatus,
  commodityOrderFinish,
  commodityOrderApprove,
  commodityOrderContractExport,
} from '@/service/getData'
import { isMobile } from '../../../util'
import { clone } from '@/util'
import {
  CommodityOrderStatusMap,
  DepartmentCategoryMap,
  CommodityOrderQuotationMap,
} from '@/config/global'
import PayFormer from './pay_former_new'
import store from '@/store/store'
import DealerSelect from '@/components/select/dealer_select'
import CustomerSelect from '@/components/select/customer_select'
import { host } from '@/config/env'
import CustomerSelector from '@/components/customer_selector'

export default {
  props: {
    status: {
      type: Number,
      default: 0,
    },
  },
  components: {
    PayFormer,
    DealerSelect,
    CustomerSelect,
    CustomerSelector,
  },
  data() {
    return {
      customerSelectorVisible: false,
      DepartmentCategoryMap,
      CommodityOrderQuotationMap,
      host,
      tableKey: '',
      userInfo: store.getters.userInfo,
      editIndex: 0,
      model: {},
      payFormVisible: false,
      CommodityOrderStatusMap,
      isMobile,
      list: [],
      loading: false,
      total: 0,
      filter: {
        size: 20,
        page: 1,
        number: '',
        part_number: '',
        date: '',
        customer_id: '',
        quotation_customer_id: '',
        dealer_id: '',
        is_quotation: '',
      },
    }
  },
  created() {
    let is_quotation = parseInt(this.$route.query.is_quotation || 0)
    if (is_quotation == 0) {
      is_quotation = ''
    }
    this.filter = {
      page: parseInt(this.$route.query.page || 1),
      size: parseInt(this.$route.query.size || 20),
      number: this.$route.query.number || '',
      part_number: this.$route.query.part_number || '',
      date: this.$route.query.date || '',
      customer_id: parseInt(this.$route.query.customer_id || 0),
      quotation_customer_id: parseInt(
        this.$route.query.quotation_customer_id || 0,
      ),
      dealer_id: parseInt(this.$route.query.dealer_id || 0),
      is_quotation: is_quotation,
    }
    this.getData()
  },
  methods: {
    requestSearch(reset = '') {
      this.filter.page = 1
      if (reset == 'reset') {
        this.filter.number = ''
        this.filter.part_number = ''
        this.filter.date = ''
        this.filter.customer_id = ''
        this.filter.quotation_customer_id = ''
        this.filter.dealer_id = ''
        this.filter.is_quotation = ''
      }
      this.getData()
    },

    async getData() {
      this.$router.replace({
        query: this.filter,
      })

      this.loading = true
      let params = clone(this.filter)
      params.page -= 1

      if (params.date && params.date.length == 2) {
        params.start_date = params.date[0]
        params.end_date = params.date[1]
      }

      params.status = this.status

      let res = await commodityOrderList(params)
      if (res.code == 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.loading = false
      }
    },
    handlePageChange(e) {
      this.filter.page = e
      this.getData()
    },

    handlePay(index, item) {
      this.editIndex = index
      this.model = {
        id: item.id,
        payed_proof: '',
        payed_remark: '',
      }
      this.payFormVisible = true
    },
    async handleCancel(item, index) {
      let res = await updateCommodityOrderStatus({ id: item.id })
      if (res.code == 0) {
        this.$set(this.list, index, res.data)
        this.$emit('updateGoingCount')
      }
    },
    updatedCallback(data) {
      this.$set(this.list, this.editIndex, data)
      this.tableKey = Math.random()
      this.$emit('updateGoingCount')
    },
    handleFinish(item, index) {
      this.$prompt('请填写Quotation码', '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: 'Quotation码不能为空',
      })
        .then(async ({ value }) => {
          let res = await commodityOrderFinish({
            id: item.id,
            quotation_number: value,
          })
          if (res.code == 0) {
            this.$set(this.list, index, res.data)
            this.tableKey = Math.random()
          }
        })
        .catch(() => {})
    },
    // handleApprove(item, index) {
    //   let data = { id: item.id, agree: true }

    //   this.$prompt('备注（驳回选填）', '订单审批', {
    //     distinguishCancelAndClose: true,
    //     confirmButtonText: '驳回',
    //     cancelButtonText: '通过',
    //     inputPlaceholder: '驳回选填',
    //     cancelButtonClass: 'btn-cacel ml-10',
    //     confirmButtonClass: 'btn-confirm',
    //     customClass: 'switch-btn',
    //   })
    //     .then(async ({ value }) => {
    //       data.agree = false
    //       data.reject_reason = value
    //       let res = await commodityOrderApprove(data)
    //       this.$set(this.list, index, res.data)
    //       this.tableKey = Math.random()
    //       this.$emit('updateGoingCount')
    //     })
    //     .catch(async (action) => {
    //       if (action == 'cancel') {
    //         let res = await commodityOrderApprove(data)
    //         this.$set(this.list, index, res.data)
    //         this.tableKey = Math.random()
    //         this.$emit('updateGoingCount')
    //       }
    //     })
    // },
    async handleContractExport(item) {
      let res = await commodityOrderContractExport(item.id)
      if (res.code == 0) {
        let href = res.data
        window.location.href = href
      }
    },
    async handleDelete(item, index) {
      let res = await deleteCommodityOrder(item.id)
      if (res.code == 0) {
        this.list.splice(index, 1)
        this.tableKey = Math.random()
      }
    },

    selectedOrderCustomer(customer) {
      this.$router.push('/dashboard/shop/orders/editor?customer=' + customer.id)
    },
  },
}
</script>
<style scoped>
.item-container {
  padding: 4px 0px;
  display: flex;
  align-content: flex-start;
  justify-content: space-between;
  width: 100%;
}
.item-info {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  width: calc(100% - 70px);
}
.item-desc {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  /* height: 36px; */
  color: #666;
  font-size: 12px;
  line-height: 18px;
}
.part-number {
  color: #3d3d3d;
  /* font-size: 16px; */
  /* font-weight: 500; */
  margin-right: 6px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.item-title {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  flex-wrap: wrap;
}
.order-time {
  /* opacity: 0.4; */
  /* font-size: 12px; */
  /* margin-left: 40px; */
  line-height: 1.2;
  margin-bottom: 4px;
}
</style>
<style>
.btn-confirm,
.btn-confirm:hover {
  background: #292b2c !important;
  border: 1px solid #292b2c !important;
}
.btn-cacel,
.btn-cacel:hover {
  background-color: #047bf8 !important;
  border-color: #047bf8 !important;
}
.switch-btn .el-message-box__btns {
  display: flex;
  flex-direction: row-reverse;
}
</style>